// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"3f959304","453":"3154de31","800":"fb3fbfb8"}[chunkId] + ".chunk.js";
};